import { render, staticRenderFns } from "./AddCallCenter.vue?vue&type=template&id=6573fa6d&scoped=true"
import script from "./AddCallCenter.vue?vue&type=script&lang=js"
export * from "./AddCallCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573fa6d",
  null
  
)

export default component.exports